<template>
  <div class="ma-8">
    <v-card class="mb-8 transparent d-flex justify-space-between" elevation="0">
      <v-btn large class="myYellow2" to="/">
        <v-icon left>mdi-chevron-left</v-icon> Back
      </v-btn>
      <v-btn large class="myGreen white--text" to="/newnotes">
        New Note <v-icon right>mdi-plus</v-icon>
      </v-btn>
    </v-card>
    <v-data-table
      v-if="getListNotes.length"
      :headers="notesHeaders"
      :items="notesDetail"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      item-key="time"
      show-expand
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Cashier Notes</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-switch
            v-model="singleExpand"
            label="Single expand"
            class="mt-2"
          ></v-switch>
        </v-toolbar>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-card class="ma-4 pa-4">Catatan : {{item.note}}</v-card>
        </td>
      </template>
    </v-data-table>
    <v-card v-else class="pa-8 d-flex justify-center"
      ><h2>TIDAK ADA CATATAN</h2></v-card
    >
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      expanded: [],
      singleExpand: false,
      notesHeaders: [
        {
          text: "Date",
          class: "text-h6 white--text primary",
          align: "start",
          sortable: false,
          value: "date",
        },
        { text: "Time", value: "time", class: "text-h6 white--text primary" },
        {
          text: "Cashier",
          value: "Name",
          class: "text-h6 white--text primary",
        },
        { text: "", value: "data-table-expand", class: "primary" },
      ],
      notesDetail: [],
    };
  },

  computed: {
    ...mapGetters(["getListNotes"]),
  },

  methods: {
    ...mapActions(["GET_LIST_NOTES"]),
  },

  mounted() {
    console.log(this.getListNotes);
    this.notesDetail = this.getListNotes;
  },

  created() {
    this.GET_LIST_NOTES();
  },
};
</script>
